import { ComponentProps, useCallback } from 'react';
import AlgoliaSearchBox from '@alltrails/search/components/AlgoliaSearchBox';
import handleNaturalLanguageResultSelect from '@/utils/handleNaturalLanguageResultSelect';
import { useAppDispatch } from '@/utils/redux';

const useNaturalLanguageResultSelect = () => {
  const dispatch = useAppDispatch();

  const onSelect = useCallback<NonNullable<ComponentProps<typeof AlgoliaSearchBox>['onNaturalLanguageResultSelect']>>(
    (query, clickPosition, selectionType, selectionMethod, searchOrigin) => {
      handleNaturalLanguageResultSelect(dispatch, query, clickPosition, selectionType, selectionMethod, searchOrigin);
    },
    [dispatch]
  );

  return onSelect;
};

export default useNaturalLanguageResultSelect;
